import { h, Component } from 'preact';
import Store from 'store/store';
import * as actions from 'store/actions';

import { getData } from 'utils/dynamicData';
import { joinClasses } from 'utils/utils';
import { renderCookieConsentLink } from 'utils/cookies';

import PageLink from 'components/pageLink/pageLink';
import ShareIcons from 'components/shareIcons/shareIcons';

import s from 'components/footer/footer.sss';

// Should this be based on build date or current date?
// Probably build date: https://stackoverflow.com/a/2391555/1336843
const copyrightDate = (typeof window !== 'undefined' ? new Date(window.__BUILD_DATE__) : new Date()).getFullYear();

export default class Footer extends Component {

	constructor(props) {
		super(props);
		this.state = {
			links: [],
			legal: [],
		};

		this.onAnyClick = this.onAnyClick.bind(this);
		this.renderLink = this.renderLink.bind(this);

		if (typeof window !== 'undefined') {
			this.loadData();
		}
	}

	async loadData() {
		try {
			const data = await getData('navigation');
			const links = (data?.footer?.links || []).map(section => (section || []).filter(Boolean)).filter(e => e?.length);
			const legal = (data?.footer?.legal || []).filter(Boolean);
			this.setState({ links, legal });
		} catch (err) {
			console.error(err);
		}
	}

	onAnyClick(e) {
		// close on internal navigation
		const link = e.target.closest('a');
		if (!link) return;

		let href = link.getAttribute('href');
		let label = link.innerText || link.textContent || '';
		const isLegalLink = link.matches(`.${s.legal} a`);
		if (isLegalLink) {
			Store.emit(actions.FOOTER_LEGAL_CLICK, { label, path: href });
		} else {
			Store.emit(actions.FOOTER_NAV_CLICK, { label });
		}
	}

	renderLink(link) {
		// Is there a way to avoid getting the store here?
		const store = Store.get();
		const isUS = store?.client?.geo?.countryCode?.toLowerCase() === 'us';

		// Only show CA Notice link for US users
		if (
			!isUS &&
			typeof link.destination === 'string' &&
			link.destination.includes('california-consumer-privacy-act')
		) {
			return null;
		}

		if (typeof link === 'string') {
			link = { name: store.appData.pages[link]?.name || link, destination: link };
		}
		if (!link?.name) return;
		if (!link.destination) {
			return <span>{link.name}</span>;
		}
		if (link.destination === 'cookies') {
			return renderCookieConsentLink(link.name);
		}
		if (/^https?:\/\//i.test(link.destination)) {
			return <a href={link.destination} target="_blank" rel="noopener noreferrer">{link.name}</a>;
		}
		return <PageLink to={link.destination}>{link.name}</PageLink>;
	}

	render(props, state) {
		return (
			<footer class={s.wrapper} onClickCapture={this.onAnyClick}>
				<div class={s.content}>
					<div class={s.main}>
						<div class={s.logo}>
							<img src={`${__IMAGE_ROOT__}/logo.svg`} width="79" height="40" alt="Universal Logo" />
						</div>
						<div class={s.linksWrapper}>
							{state.links.map(section => (
								<div class={joinClasses(s.section, s.links)}>
									{section.map(this.renderLink)}
								</div>
							))}
						</div>
						<div class={s.shareWrapper}>
							<ShareIcons class={s.share} id="footer" />
						</div>
					</div>
					<div class={s.legal}>
						{state.legal.map(this.renderLink)}
					</div>
					<div class={s.copyright}>© {copyrightDate} Universal Pictures</div>
				</div>
			</footer>
		);
	}

}